export interface SeatAnchors {
  readonly at200: number;
  readonly at1000: number;
  readonly at5000: number;
}

const roundHalfUpRatio = (numerator: number, denominator: number): number =>
  Math.floor((2 * numerator + denominator) / (2 * denominator));

export function seatMonthlyAmount(seats: number, anchors: SeatAnchors): number {
  if (seats <= 1000) {
    return roundHalfUpRatio(
      anchors.at200 * 800 + (seats - 200) * (anchors.at1000 - anchors.at200),
      800,
    );
  }

  return roundHalfUpRatio(
    anchors.at1000 * 4000 + (seats - 1000) * (anchors.at5000 - anchors.at1000),
    4000,
  );
}

export function seatCommitAmount(monthly: number, discountPercent: number): number {
  return roundHalfUpRatio(monthly * (100 - discountPercent), 100);
}
